module.exports = __webpack_public_path__ + "img/pitie.60ff034c.jpg";